import { CartAddEvent, CartErrorEvent } from '@theme/events';

class HomepageProduct extends HTMLElement {
  /** @type {Element} */
  source;

  /** @type {Element} */
  destination;

  /** @type {Object} */
  selectors = {
    variantInput: '[js-variant-input]',
    addToCart: '[js-add-to-cart]',
  };

  connectedCallback() {
    this.variantInputs = this.querySelectorAll(this.selectors.variantInput);
    this.addToCart = this.querySelector(this.selectors.addToCart);
    this.setListener();
  }

  setListener() {
    this.variantInputs.forEach(input => {
      input.addEventListener('change', this.handleVariantChange);
    });

    this.addToCart.addEventListener('click', this.handleAddToCart);
  }

  handleVariantChange = (event) => {
    this.variantId = Number(event.target.value);
    const product = JSON.parse(this.dataset.product);
    const variant = product.variants.find(variant => variant.id === this.variantId);
    if (variant) {
      if (variant.available) {
        this.updateATCButton(true);
      } else {
        this.updateATCButton(false);
      }
    } else{
      this.updateATCButton(false);
    }
  }

  updateATCButton(available) {
    if (available) {
      this.addToCart.disabled = false;
    } else {
      this.addToCart.disabled = true;
    }
  }

  handleAddToCart = () => {
    this.updateATCButton(false);

    const formData = new FormData();
    formData.append('id', this.variantId);
    formData.append('quantity', 1);

    fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 
        Accept: `application/javascript`, 
        'X-Requested-With': 'XMLHttpRequest' 
      },
      body: formData
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      if (response.status) {
        this.dispatchEvent(
          new CartErrorEvent(this.variantId.toString() || '', response.message, response.description, response.errors)
        );

        console.error('Cart error:', response.description);
        return;
      }
      
      this.dispatchEvent(
        new CartAddEvent({}, this.variantId.toString(), {
          source: 'homepage-product',
          itemCount: Number(formData.get('quantity')),
          productId: this.dataset.productId,
          sections: response.sections,
        })
      );
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    })
    .finally(() => {
      this.updateATCButton(true);
    });
  }
}

if (!customElements.get('homepage-product')) {
  customElements.define('homepage-product', HomepageProduct);
}
